import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../shared/widgets/value-accessors/object-value-accessor';
import { MemberService } from '../../member/shared/member.service';
import { MemberActivityTypeModel } from '../../member/shared/member-activity-type.model';
import { FormBuilderSettings } from '../shared/model/settings/form-builder-settings.model';
import { ValidationResult } from '../../shared/widgets/validators/validation-result.model';
import { TranslationService, UtilService } from '../../shared/index';
import { FormBuilderNotificationEmail } from '../shared/model/settings/form-builder-notification-email.model';
import { ProfileOrgIndEnum } from '../shared/model/settings/profile-org-ind-enum.model';
import { AffCode } from 'src/app/affcode/shared/affcode.model';
//import { publicDecrypt } from 'crypto';

@Component({
  selector: 'wl-form-builder-settings',
  templateUrl: 'form-builder-settings.component.html',
  providers: [
    CreateObjectValueAccessorProvider(FormBuilderSettingsComponent),
    CreateObjectValueValidationProvider(FormBuilderSettingsComponent),
    MemberService,
  ],
    standalone: false
})
export class FormBuilderSettingsComponent extends ObjectValueAccessor<FormBuilderSettings> implements OnInit {
  activityTypes: Array<MemberActivityTypeModel>;
  public loading: boolean;

  public profileOrgInd = ProfileOrgIndEnum;

  private _showEditor = false;
  @Input() public get showEditor() {
    return this._showEditor;
  }
  set showEditor(value: boolean) {
    this._showEditor = value;
  }

  public constructor(
    private _memberService: MemberService,
    private _translationService: TranslationService,
    private _utilService: UtilService
  ) {
    super(new FormBuilderSettings(), true);
    this.activityTypes = [];
    this.loading = true;
  }

  ngOnInit(): void {
    this._memberService.getMemberActivityTypes().then((results) => {
      this.activityTypes = results.filter((x) => x.AddCode);
      this.loading = false;
    });
  }

  public isValid = (): boolean => {
    let valid: boolean = true;
    this.validationError = '';
    if (!this.value || this.loading) {
      return false;
    }
    if (!this.value.FormPaymentOptions.AllowBillMeOption && !this.value.FormPaymentOptions.AllowCreditCardOption) {
      valid = false;
      this.validationError = this._translationService.getInstant('forms.form-builder.form-settings.validation-errors.no-payment-type');
    }
    if (this.value.ActivityTypeId <= 0) {
      valid = false;
      this.validationError = this._translationService.getInstant('forms.form-builder.form-settings.validation-errors.no-activity-type');
    }
    if (this.value.CommunicationOptions.NotificationEmails.some((x) => !x.Email || !this._utilService.isValidEmail(x.Email))) {
      valid = false;
      this.validationError = this._translationService.getInstant('forms.form-builder.form-settings.validation-errors.bad-email');
    }
    return valid;
  };

  public newNotificationEmail = (): void => {
    this.value.CommunicationOptions.NotificationEmails.push(new FormBuilderNotificationEmail());
  };

  public removeNotificationEmail = (i: number): void => {
    this.value.CommunicationOptions.NotificationEmails.splice(i, 1);
  };

  public allowArbChanged(v: boolean) {
    this.value.FormPaymentOptions.RequireArb = v && this.value.FormPaymentOptions.RequireArb;
  }
}
